export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },

  {
    title: that.$l('table_label_goodsSizeSpec') || '规格尺寸',
    field: 'goodsSizeSpec',
    minWidth: 210,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_case_pack') || 'Case Pack',
    field: 'quotationCasePack',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_MOQ') || 'MOQ',
    field: 'quotationMoq',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'quotationMoq' },
  },
  {
    title: that.$l('table_label_Price') || 'Price',
    field: 'quotationPrice',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    // slots: { default: 'quotationPrice' },
  },
]
